// Handbook action
export const GET_LEADER_REQUESTED = 'GET_LEADER_REQUESTED'
export const GET_LEADER_SUCCESS = 'GET_LEADER_SUCCESS'
export const GET_DEPARTMENTS_REQUESTED = 'GET_DEPARTMENTS_REQUESTED'
export const GET_DEPARTMENTS_SUCCESS = 'GET_DEPARTMENTS_SUCCESS'
export const GET_FULL_NAME_REQUESTED = 'GET_FULL_NAME_REQUESTED'
export const GET_DEPARTMENTS_TAB = 'GET_DEPARTMENTS_TAB'
export const GET_DEPARTMENTS_TAB_SUCCESS = 'GET_DEPARTMENTS_TAB_SUCCESS'

export const RESET_ALL_OPTIONS = 'RESET_ALL_OPTIONS'
export const GET_FULL_NAME_SUCCESS = 'GET_FULL_NAME_SUCCESS'
export const GET_DEAL_NUMBER = 'GET_DEAL_NUMBER'
export const GET_DEAL_NUMBER_SUCCESS = 'GET_DEAL_NUMBER_SUCCESS'
export const CLEAR_ERROR_SUCCESS = 'CLEAR_ERROR_SUCCESS'
export const OPEN_MODAL_SUCCESS = 'OPEN_MODAL_SUCCESS'
export const REQUEST_PUT_SUCCESS = 'REQUEST_PUT_SUCCESS'
export const GET_CASHBOX_REQUESTED = 'GET_CASHBOX_REQUESTED'
export const GET_CASHBOX_SUCCESS = 'GET_CASHBOX_SUCCESS'
export const GET_CASHBOX_FAILED = 'GET_CASHBOX_FAILED'
export const ADD_CASHBOX_REQUESTED = 'ADD_CASHBOX_REQUESTED'
export const ADD_CASHBOX_SUCCESS = 'ADD_CASHBOX_SUCCESS'
export const ADD_CASHBOX_FAILED = 'ADD_CASHBOX_FAILED'
export const CASHBOX_RESET = 'CASHBOX_RESET'
export const GET_EMPLOYEES_REQUESTED = 'GET_EMPLOYEES_REQUESTED'
export const GET_DEPARTMENTLEADER_REQUESTED = 'GET_DEPARTMENTLEADER_REQUESTED'
export const GET_DEPARTMENTLEADER_SUCCESS = 'GET_DEPARTMENTLEADER_SUCCESS'
export const GET_DEPARTMENTLEADER_FAILED = 'GET_DEPARTMENTLEADER_FAILED'
export const GET_CHIEFACCOUNTANT_REQUESTED = 'GET_CHIEFACCOUNTANT_REQUESTED'
export const GET_CHIEFACCOUNTANT_SUCCESS = 'GET_CHIEFACCOUNTANT_SUCCESS'
export const GET_CHIEFACCOUNTANT_FAILED = 'GET_CHIEFACCOUNTANT_FAILED'
export const GET_ACCOUNTANT_REQUESTED = 'GET_ACCOUNTANT_REQUESTED'
export const GET_ACCOUNTANT_SUCCESS = 'GET_ACCOUNTANT_SUCCESS'
export const GET_ACCOUNTANT_FAILED = 'GET_ACCOUNTANT_FAILED'
export const GET_SENIORCOMMODITYEXPERT_REQUESTED = 'GET_SENIORCOMMODITYEXPERT_REQUESTED'
export const GET_SENIORCOMMODITYEXPERT_SUCCESS = 'GET_SENIORCOMMODITYEXPERT_SUCCESS'
export const GET_SENIORCOMMODITYEXPERT_FAILED = 'GET_SENIORCOMMODITYEXPERT_FAILED'
export const GET_GOODSSPECIALIST_REQUESTED = 'GET_GOODSSPECIALIST_REQUESTED'
export const GET_GOODSSPECIALIST_SUCCESS = 'GET_GOODSSPECIALIST_SUCCESS'
export const GET_GOODSSPECIALIST_FAILED = 'GET_GOODSSPECIALIST_FAILED'
export const GET_EMPLOYEE_REQUESTED = 'GET_EMPLOYEE_REQUESTED'
export const GET_EMPLOYEE_SUCCESS = 'GET_EMPLOYEE_SUCCESS'
export const GET_EMPLOYEE_FAILED = 'GET_EMPLOYEE_FAILED'
export const GET_REASONS_REQUESTED = 'GET_REASONS_REQUESTED'
export const GET_REASONS_SUCCESS = 'GET_REASONS_SUCCESS'
export const GET_REASONS_FAILED = 'GET_REASONS_FAILED'
export const HANDBOOK_RESET = 'HANDBOOK_RESET'
export const ADD_BRANCH_REQUESTED = 'ADD_BRANCH_REQUESTED'
export const ADD_BRANCH_SUCCESS = 'ADD_BRANCH_SUCCESS'
export const GET_BRANCHES_REQUESTED = 'GET_BRANCHES_REQUESTED'
export const GET_BRANCHES_SUCCESS = 'GET_BRANCHES_SUCCESS'
export const CHANGE_BRANCH_REQUESTED = 'CHANGE_BRANCH_REQUESTED'
export const CHANGE_BRANCH_SUCCESS = 'CHANGE_BRANCH_SUCCESS'
export const DELETE_BRANCH_REQUESTED = 'DELETE_BRANCH_REQUESTED'
export const DELETE_BRANCH_SUCCESS = 'DELETE_BRANCH_SUCCESS'
export const BRANCH_FAILED = 'BRANCH_FAILED'
export const PAGE_BRANCH_FAILED = 'PAGE_BRANCH_FAILED'
export const RESET_HANDBOOK_ERROR = 'RESET_HANDBOOK_ERROR'
export const CHANGE_AD_IMAGE_REQUESTED = 'CHANGE_AD_IMAGE_REQUESTED'
export const CHANGE_AD_IMAGE_SUCCESS = 'CHANGE_AD_IMAGE_SUCCESS'
export const GET_AD_IMAGE_REQUESTED = 'GET_AD_IMAGE_REQUESTED'
export const GET_AD_IMAGE_SUCCESS = 'GET_AD_IMAGE_SUCCESS'
export const DELETE_AD_IMAGE_REQUESTED = 'DELETE_AD_IMAGE_REQUESTED'
export const DELETE_AD_IMAGE_SUCCESS = 'DELETE_AD_IMAGE_SUCCESS'
export const AD_IMAGE_FAILED = 'AD_IMAGE_FAILED'


// ClientAdd action
export const ADD_CLIENT_REQUESTED = 'ADD_CLIENT_REQUESTED'
export const ADD_CLIENT_SUCCESS = 'ADD_CLIENT_SUCCESS'
export const GET_COUNTRY_REQUESTED = 'GET_COUNTRY_REQUESTED'
export const GET_COUNTRY_SUCCESS = 'GET_COUNTRY_SUCCESS'
export const GET_COUNTRY_FAILED = 'GET_COUNTRY_FAILED'
export const CLEAR_CONDITION_SUCCESS = 'CLEAR_CONDITION_SUCCESS'
export const CLIENT_FAILED = 'CLIENT_FAILED'

// QuickCalculation action
export const GET_CALCULATION_REQUESTED = 'GET_CALCULATION_REQUESTED'
export const GET_CALCULATION_SUCCESS = 'GET_CALCULATION_SUCCESS'
export const GET_CALCULATION_FAILED = 'GET_CALCULATION_FAILED'
export const QUICK_CALCULATION_RESET = 'QUICK_CALCULATION_RESET'
export const SAVE_CALCULATION = 'SAVE_CALCULATION'
export const NOT_SAVE_CALCULATION = 'NOT_SAVE_CALCULATION'

// Dashboard action
export const GET_AVAILABLEDEPARTMENTS_REQUESTED = 'GET_AVAILABLEDEPARTMENTS_REQUESTED'
export const GET_AVAILABLEDEPARTMENTS_SUCCESS = 'GET_AVAILABLEDEPARTMENTS_SUCCESS'
export const GET_WORKSESSION_REQUESTED = 'GET_WORKSESSION_REQUESTED'
export const GET_WORKSESSION_SUCCESS = 'GET_WORKSESSION_SUCCESS'
export const DASHBOARD_FAILED = 'DASHBOARD_FAILED'
export const DASHBOARD_RESET = 'DASHBOARD_RESET'

// Clients action
export const GET_PARTIAL_QUENCHING_DATA_REQUESTED = 'GET_NEXT_CONTRACT_NUMBER_REQUESTED'
export const GET_PARTIAL_QUENCHING_DATA_SUCCESS = 'GET_NEXT_CONTRACT_NUMBER_SUCCESS'
export const GET_PARTIAL_QUENCHING_DATA_FAILED = 'GET_NEXT_CONTRACT_NUMBER_FAILED'
export const PARTIAL_QUENCHING_DATA_CLEAR = 'PARTIAL_QUENCHING_DATA_CLEAR'
export const CONTRACT_PARTIAL_QUENCHING_REQUESTED ='CONTRACT_PARTIAL_QUENCHING_REQUESTED'
export const CONTRACT_PARTIAL_QUENCHING_SUCCESS = 'CONTRACT_PARTIAL_QUENCHING_SUCCESS'
export const CONTRACT_PARTIAL_QUENCHING_FAILED = 'CONTRACT_PARTIAL_QUENCHING_FAILED'

export const GET_CLIENTS_REQUESTED = 'GET_CLIENTS_REQUESTED'
export const GET_CLIENTS_SUCCESS = 'GET_CLIENTS_SUCCESS'
export const CLIENTS_FAILED = 'CLIENTS_FAILED'
export const PUT_COMPOSEPROFILES_REQUESTED = 'PUT_COMPOSEPROFILES_REQUESTED'
export const PUT_COMPOSEPROFILES_SUCCESS = 'PUT_COMPOSEPROFILES_SUCCESS'
export const PUT_COMPOSEPROFILES_FAILED = 'PUT_COMPOSEPROFILES_FAILED'
export const CLIENTS_RESET = 'CLIENTS_RESET'
export const PRINT_CLIENT_PROFILE = 'PRINT_CLIENT_PROFILE'
export const PRINT_CLIENT_PROFILE_FAILED = 'PRINT_CLIENT_PROFILE_FAILED'

// Contract action
export const GET_ACCEPTANCE_CERTIFICATE = 'GET_ACCEPTANCE_CERTIFICATE'
export const LOAD_PRA_FAILED = 'LOAD_PRA_FAILED'
export const OPEN_ALERT_PRA = 'OPEN_ALERT_PRA'
export const LOAD_PRA_SUCCESS = 'LOAD_PRA_SUCCESS'
export const LOAD_PRA_FILE = 'LOAD_PRA_FILE'
export const STATE_LOADER = 'STATE_LOADER'
export const CHANGE_STATE_PRA_MODAL = 'CHANGE_STATE_PRA_MODAL'
export const SET_LOAD_PRA_FILE = 'SET_LOAD_PRA_FILE'
export const GET_CLIENTCONTRACTS_REQUESTED = 'GET_CLIENTCONTRACTS_REQUESTED'
export const GET_CLIENTCONTRACTS_SUCCESS = 'GET_CLIENTCONTRACTS_SUCCESS'
export const GET_CLIENTCONTRACTS_FAILED = 'GET_CLIENTCONTRACTS_FAILED'
export const ADD_CLIENTCONTRACTS_REQUESTED = 'ADD_CLIENTCONTRACTS_REQUESTED'
export const ADD_CLIENTCONTRACTS_SUCCESS = 'ADD_CLIENTCONTRACTS_SUCCESS'
export const ADD_CLIENTCONTRACTS_FAILED = 'ADD_CLIENTCONTRACTS_FAILED'
export const GET_CLIENTCONTRACT_REQUESTED = 'GET_CLIENTCONTRACT_REQUESTED'
export const GET_CLIENTCONTRACT_SUCCESS = 'GET_CLIENTCONTRACT_SUCCESS'
export const GET_CLIENTCONTRACT_FAILED = 'GET_CLIENTCONTRACT_FAILED'
export const GET_PROLONGCALCULATE_REQUESTED = 'GET_PROLONGCALCULATE_REQUESTED'
export const GET_PROLONGCALCULATE_SUCCESS = 'GET_PROLONGCALCULATE_SUCCESS'
export const GET_PROLONGCALCULATE_FAILED = 'GET_PROLONGCALCULATE_FAILED'
export const ADD_PROLONGCALCULATE_REQUESTED = 'ADD_PROLONGCALCULATE_REQUESTED'
export const ADD_PROLONGCALCULATE_SUCCESS = 'ADD_PROLONGCALCULATE_SUCCESS'
export const ADD_PROLONGCALCULATE_FAILED = 'ADD_PROLONGCALCULATE_FAILED'
export const CHANGE_CLIENTCONTRACT_REQUESTED = 'CHANGE_CLIENTCONTRACT_REQUESTED'
export const OVERESTIMATION_REQUEST_SUCCESS = 'OVERESTIMATION_REQUEST_SUCCESS'
export const CHANGE_CLIENTCONTRACT_SUCCESS = 'CHANGE_CLIENTCONTRACT_SUCCESS'
export const CHANGE_CLIENTCONTRACT_FAILED = 'CHANGE_CLIENTCONTRACT_FAILED'
export const GET_OPERATIONSCONTRACT_REQUESTED = 'GET_OPERATIONSCONTRACT_REQUESTED'
export const GET_OPERATIONSCONTRACT_SUCCESS = 'GET_OPERATIONSCONTRACT_SUCCESS'
export const GET_OPERATIONSCONTRACT_FAILED = 'GET_OPERATIONSCONTRACT_FAILED'
export const CHANGE_CONTRACTSTATUSES_REQUESTED = 'CHANGE_CONTRACTSTATUSES_REQUESTED'
export const CHANGE_CONTRACTSTATUSES_REFUND_REQUESTED = 'CHANGE_CONTRACTSTATUSES_REFUND_REQUESTED'
export const CHANGE_CONTRACTSTATUSES_CLOSE_REQUESTED = 'CHANGE_CONTRACTSTATUSES_CLOSE_REQUESTED'
export const CHANGE_CONTRACTSTATUSES_SUCCESS = 'CHANGE_CONTRACTSTATUSES_SUCCESS'
export const CHANGE_CONTRACTSTATUSES_FAILED = 'CHANGE_CONTRACTSTATUSES_FAILED'
export const GET_TRANSACTIONS_REQUESTED = 'GET_TRANSACTIONS_REQUESTED'
export const GET_PAYMENTS_ANNUITY_REQUESTED = 'GET_PAYMENTS_ANNUITY_REQUESTED'
export const GET_CALC_ANNUITY_CLOSE_DEAL_REQUESTED = 'GET_ANNUITY_CLOSE_DEAL_REQUESTED'
export const CLOSE_ANNUITY_STATE = 'CLOSE_ANNUITY_STATE'
export const ANNUITY_PERIOD_STATE = 'ANNUITY_PERIOD_STATE'
export const CLOSE_ANNUITY_DEAL_REQUESTED = 'CLOSE_ANNUITY_DEAL_REQUESTED'
export const CLOSE_ANNUITY_DEAL_SUCCESS = 'CLOSE_ANNUITY_DEAL_SUCCESS'
export const CLOSE_ANNUITY_DEAL_FAILED = 'CLOSE_ANNUITY_DEAL_FAILED'
export const GET_CALC_ANNUITY_CLOSE_DEAL_SUCCESS = 'GET_ANNUITY_CLOSE_DEAL_SUCCESS'
export const GET_CALC_ANNUITY_CLOSE_DEAL_FAILED = 'GET_ANNUITY_CLOSE_DEAL_FAILED'
export const GET_PAYMENTS_ANNUITY_SUCCESS = 'GET_PAYMENTS_ANNUITY_SUCCESS'
export const GET_PAYMENTS_ANNUITY_FAILED = 'GET_PAYMENTS_ANNUITY_FAILED'
export const PAY_ANNUITY_PERIOD_REQUESTED = 'PAY_ANNUITY_PERIOD_REQUESTED'
export const PAY_ANNUITY_PERIOD_SUCCESS = 'PAY_ANNUITY_PERIOD_SUCCESS'
export const PAY_ANNUITY_PERIOD_FAILED = 'PAY_ANNUITY_PERIOD_FAILED'
export const GET_TRANSACTIONS_SUCCESS = 'GET_TRANSACTIONS_SUCCESS'
export const GET_TRANSACTIONS_FAILED = 'GET_TRANSACTIONS_FAILED'
export const RESET_TRANSACTIONS = 'RESET_TRANSACTIONS'
export const CHANGE_POSITIONSCONTRACT_REQUESTED = 'CHANGE_POSITIONSCONTRACT_REQUESTED'
export const CHANGE_POSITIONSCONTRACT_SUCCESS = 'CHANGE_POSITIONSCONTRACT_SUCCESS'
export const CHANGE_POSITIONSCONTRACT_FAILED = 'CHANGE_POSITIONSCONTRACT_FAILED'
export const TRANSFER_DEALS_REQUESTED = 'TRANSFER_DEALS_REQUESTED'
export const TRANSFER_DEALS_SUCCESS = 'TRANSFER_DEALS_SUCCESS'
export const TRANSFER_DEALS_FAILED = 'TRANSFER_DEALS_FAILED'
export const GET_INVENTORIES_REQUESTED = 'GET_INVENTORIES_REQUESTED'
export const GET_INVENTORIES_SUCCESS = 'GET_INVENTORIES_SUCCESS'
export const GET_INVENTORIES_FAILED = 'GET_INVENTORIES_FAILED'
export const GET_INVENTORYDEALS_REQUESTED = 'GET_INVENTORYDEALS_REQUESTED'
export const GET_INVENTORYDEALS_SUCCESS = 'GET_INVENTORYDEALS_SUCCESS'
export const GET_INVENTORYDEALS_FAILED = 'GET_INVENTORYDEALS_FAILED'
export const GET_DEALSFORTRANSFER_REQUESTED = 'GET_DEALSFORTRANSFER_REQUESTED'
export const GET_DEALSFORTRANSFER_SUCCESS = 'GET_DEALSFORTRANSFER_SUCCESS'
export const STATE_MODAL_ADD_CONTRACT = 'STATE_MODAL_ADD_CONTRACT'
export const GET_DEALSFORTRANSFER_FAILED = 'GET_DEALSFORTRANSFER_FAILED'
export const TRANSFER_SALED_REQUESTED = 'TRANSFER_SALED_REQUESTED'
export const TRANSFER_SALED_SUCCESS = 'TRANSFER_SALED_SUCCESS'
export const TRANSFER_SALED_FAILED = 'TRANSFER_SALED_FAILED'
export const OVERESTIMATION_DEALS_REQUESTED = 'OVERESTIMATION_DEALS_REQUESTED'
export const OVERESTIMATION_DEALS_SUCCESS = 'OVERESTIMATION_DEALS_SUCCESS'
export const OVERESTIMATION_DEALS_FAILED = 'OVERESTIMATION_DEALS_FAILED'
export const CANCEL_OPERATION_REQUESTED = 'CANCEL_OPERATION_REQUESTED'
export const CANCEL_OPERATION_SUCCESS = 'CANCEL_OPERATION_SUCCESS'
export const CANCEL_OPERATION_FAILED = 'CANCEL_OPERATION_FAILED'
export const GET_PRINTEDFORM_REQUEST = 'GET_PRINTEDFORM_REQUEST'
export const GET_PRINTED_FORM_AUTO_LOMBARD_REQUEST = 'GET_PRINTED_FORM_AUTO_LOMBARD_REQUEST'
export const GET_PRINTEDFORM_SUCCESS = 'GET_PRINTEDFORM_SUCCESS'
export const GET_PRINTEDFORM_FAILED = 'GET_PRINTEDFORM_FAILED'
export const GET_CLIENTSCOUNT_RERQUEST = 'GET_CLIENTSCOUNT_RERQUEST'
export const GET_CLIENTSCOUNT_SUCCESS = 'GET_CLIENTSCOUNT_SUCCESS'
export const GET_CLIENTSCOUNT_FAILED = 'GET_CLIENTSCOUNT_FAILED'
export const RESET_CLIENTS_COUNT = 'RESET_CLIENTS_COUNT';
export const CONTRACT_STATE_RESET = 'CONTRACT_STATE_RESET'
export const CONTRACT_SAVE_RESET = 'CONTRACT_SAVE_RESET'
export const PROLONG_CALCULATE_CLEAR = 'PROLONG_CALCULATE_CLEAR'
export const CHANGE_CONTRACT_CLEAR = 'CHANGE_CONTRACT_CLEAR'
export const CONTRACT_ID_CLEAR = 'CONTRACT_ID_CLEAR'
export const CLIENT_CONTRACT_CLEAR = 'CLIENT_CONTRACT_CLEAR'
export const CANCEL_CONTRACT_REQUEST = 'CANCEL_CONTRACT_REQUEST'
export const CANCEL_CONTRACT_SUCCESS = 'CANCEL_CONTRACT_SUCCESS'
export const CANCEL_CONTRACT_FAILED = 'CANCEL_CONTRACT_FAILED'
export const MODAL_ERROR_CLEAR = 'MODAL_ERROR_CLEAR'
export const SET_MODAL_ERROR = 'SET_MODAL_ERROR'
export const TRANSFER_TO_RETENTION_REQUESTED = 'TRANSFER_TO_RETENTION_REQUESTED'
export const TRANSFER_TO_RETENTION_SUCCESS = 'TRANSFER_TO_RETENTION_SUCCESS'
export const TRANSFER_TO_RETENTION_FAILED = 'TRANSFER_TO_RETENTION_FAILED'
export const SWITCH_CONTRACT_JEWELLERY = 'SWITCH_CONTRACT_JEWELLERY'
export const SWITCH_CONTRACT_THINGS = 'SWITCH_CONTRACT_THINGS'
export const SWITCH_CONTRACT_CARS = 'SWITCH_CONTRACT_CARS'
export const CONTRACT_ERROR_CLEAR = 'CONTRACT_ERROR_CLEAR'
export const SET_SELECTED_ITEMS = 'SET_SELECTED_ITEMS'
export const RESET_SELECTED_ITEMS = 'RESET_SELECTED_ITEMS'
export const GET_WEB_FORM_SUCCESS = 'GET_WEB_FORM_SUCCESS'
export const RESET_WEB_FORM = 'RESET_WEB_FORM'

// User action
export const GET_LISTUSERS_REQUESTED = 'GET_LISTUSERS_REQUESTED'
export const GET_LISTUSERS_SUCCESS = 'GET_LISTUSERS_SUCCESS'
export const GET_LISTUSERS_FAILED = 'GET_LISTUSERS_FAILED'
export const GET_CURRENTUSER_REQUESTED = 'GET_CURRENTUSER_REQUESTED'
export const GET_CURRENTUSER_SUCCESS = 'GET_CURRENTUSER_SUCCESS'
export const GET_CURRENTUSER_FAILED = 'GET_CURRENTUSER_FAILED'
export const GET_FEATURES = 'GET_FEATURES'
export const GET_FEATURES_SUCCESS = 'GET_FEATURES_SUCCESS'

// Notification action
export const CHANGE_CLIENT_TO_NOTIFICATION_LIST = 'CHANGE_CLIENT_TO_NOTIFICATION_LIST'
export const RESET_CLIENT_TO_NOTIFICATION_LIST = 'RESET_CLIENT_TO_NOTIFICATION_LIST'
export const OPEN_CLIENT_TO_NOTIFICATION_LIST = 'OPEN_CLIENT_TO_NOTIFICATION_LIST'
export const OPEN_WRITE_MESSAGE_MODAL = 'OPEN_WRITE_MESSAGE_MODAL'
export const SEND_MESSAGE_REQUESTED = 'SEND_MESSAGE_REQUESTED'
export const SEND_MESSAGE_SUCCESS = 'SEND_MESSAGE_SUCCESS'
export const SEND_MESSAGE_FAILED = 'SEND_MESSAGE_FAILED'
export const GET_NOTIFICATIONS_LIST_REQUESTED = 'GET_NOTIFICATIONS_LIST_REQUESTED'
export const GET_NOTIFICATIONS_LIST_SUCCESS = 'GET_NOTIFICATIONS_LIST_SUCCESS'
export const GET_NOTIFICATIONS_LIST_FAILED = 'GET_NOTIFICATIONS_LIST_FAILED'
export const CLIENT_DELETED_FROM_THE_LIST ='CLIENT_DELETED_FROM_THE_LIST'

// Search action
export const GET_JEWELSBYVALUE_REQUESTED = 'GET_JEWELSBYVALUE_REQUESTED'
export const GET_JEWELSBYVALUE_SUCCESS = 'GET_JEWELSBYVALUE_SUCCESS'
export const GET_JEWELSBYVALUE_FAILED = 'GET_JEWELSBYVALUE_FAILED'
export const GET_CLIENTFACETS_REQUESTED = 'GET_CLIENTFACETS_REQUESTED'
export const GET_CLIENTFACETS_SUCCESS = 'GET_CLIENTFACETS_SUCCESS'
export const GET_CLIENTFACETS_FAILED = 'GET_CLIENTFACETS_FAILED'
export const GET_SEARCHCLIENTS_REQUESTED = 'GET_SEARCHCLIENTS_REQUESTED'
export const GET_SEARCHCLIENTS_SUCCESS = 'GET_SEARCHCLIENTS_SUCCESS'
export const GET_SEARCHCLIENTS_FAILED = 'GET_SEARCHCLIENTS_FAILED'
export const GET_GLOBALSEARCH_REQUESTED = 'GET_GLOBALSEARCH_REQUESTED'
export const GET_DEALFACETS_REQUESTED = 'GET_DEALFACETS_REQUESTED'
export const GET_DEALFACETS_SUCCESS = 'GET_DEALFACETS_SUCCESS'
export const GET_DEALFACETS_FAILED = 'GET_DEALFACETS_FAILED'
export const GET_SEARCHDEALS_REQUESTED = 'GET_SEARCHDEALS_REQUESTED'
export const GET_SEARCHDEALS_SUCCESS = 'GET_SEARCHDEALS_SUCCESS'
export const GET_SEARCHDEALS_FAILED = 'GET_SEARCHDEALS_FAILED'
export const GET_CRIMINAL_REQUESTED = 'GET_CRIMINAL_REQUESTED'
export const GET_CRIMINAL_SUCCESS = 'GET_CRIMINAL_SUCCESS'
export const GET_CRIMINAL_FAILED = 'GET_CRIMINAL_FAILED'
export const GET_GOVERNMENT_AGENCY_REQUESTED = 'GET_GOVERNMENT_AGENCY_REQUESTED'
export const GET_GOVERNMENT_AGENCY_SUCCESS = 'GET_GOVERNMENT_AGENCY_SUCCESS'
export const GET_GOVERNMENT_AGENCY_FAILED = 'GET_GOVERNMENT_AGENCY_FAILED'
export const SEARCH_RESET = 'SEARCH_RESET'
export const FETCH_DEAL_NUMBERS_REQUEST = 'FETCH_DEAL_NUMBERS_REQUEST';
export const FETCH_DEAL_NUMBERS_SUCCESS = 'FETCH_DEAL_NUMBERS_SUCCESS';
export const FETCH_DEAL_NUMBERS_FAILURE = 'FETCH_DEAL_NUMBERS_FAILURE';


// kb-exchange
export const GET_KB_MESSAGES_REQUESTED = "GET_KB_MESSAGES_REQUESTED"
export const GET_KB_MESSAGES_SUCCESS = "GET_KB_MESSAGES_SUCCESS"
export const GET_KB_MESSAGES_FAILED = "GET_KB_MESSAGES_FAILED"
export const CLEAR_KB_MESSAGES_ERROR = "CLEAR_KB_MESSAGES_ERROR"

export const CREATE_KB_MESSAGES_REQUESTED = "CREATE_KB_MESSAGES_REQUESTED"
export const CREATE_KB_MESSAGES_SUCCESS = "CREATE_KB_MESSAGES_SUCCESS"
export const CREATE_KB_MESSAGES_FAILED = "CREATE_KB_MESSAGES_FAILED"

// Transactions action
export const GET_LASTTRANSACTION_REQUESTED = 'GET_LASTTRANSACTION_REQUESTED'
export const GET_LASTTRANSACTION_SUCCESS = 'GET_LASTTRANSACTION_SUCCESS'
export const GET_LASTTRANSACTION_FAILED = 'GET_LASTTRANSACTION_FAILED'
export const GET_LASTTRANSACTIONBATCH_REQUESTED = 'GET_LASTTRANSACTIONBATCH_REQUESTED'
export const GET_LASTTRANSACTIONBATCH_SUCCESS = 'GET_LASTTRANSACTIONBATCH_SUCCESS'
export const GET_LASTTRANSACTIONBATCH_FAILED = 'GET_LASTTRANSACTIONBATCH_FAILED'
export const EDIT_TRANSACTION_REQUESTED = 'EDIT_TRANSACTION_REQUESTED'
export const EDIT_TRANSACTION_SUCCESS = 'EDIT_TRANSACTION_SUCCESS'
export const EDIT_TRANSACTION_FAILED = 'EDIT_TRANSACTION_FAILED'

//ClientShortInfoAction
export const GET_SHORT_INFO_REQUESTED = 'GET_SHORT_INFO_REQUESTED'
export const GET_SHORT_INFO_SUCCESS = 'GET_SHORT_INFO_SUCCESS'
export const GET_SHORT_INFO_FAILED = 'GET_SHORT_INFO_FAILED'
export const GET_SHORT_CASHBOXES_REQUESTED = 'GET_SHORT_CASHBOXES_REQUESTED'
export const GET_SHORT_CASHBOXES_LIST_SUCCESS = 'GET_SHORT_CASHBOXES_LIST_SUCCESS'
export const GET_SHORT_CASHBOXES_LIST_FAILED = 'GET_SHORT_CASHBOXES_LIST_FAILED'
export const ACTIVATE_CLIENT_SHORT_INFO_SAGA = 'ACTIVATE_CLIENT_SHORT_INFO_SAGA'
export const CHANGE_CLIENT_SHORT_INFO_REQUESTED = 'CHANGE_STATUS_CLIENT_SHORT_INFO_REQUESTED'
export const CHANGE_CLIENT_SHORT_INFO_SUCCESS = 'CHANGE_STATUS_CLIENT_SHORT_INFO_SUCCESS'
export const CHANGE_CLIENT_SHORT_INFO_FAILED = 'CHANGE_STATUS_CLIENT_SHORT_INFO_FAILED'
export const GET_CLIENT_DETAILS_REQUEST='GET_CLIENT_DETAILS_REQUEST'
export const GET_CLIENT_DETAILS_SUCCESS='GET_CLIENT_DETAILS_SUCCESS'
export const GET_CLIENT_DETAILS_FAILED='GET_CLIENT_DETAILS_FAILED'
export const SHORT_INFO_RESET = 'SHORT_INFO_RESET'
export const ACCESS_TO_CONTRACT_CREATION_ERROR='ACCESS_TO_CONTRACT_CREATION_ERROR'

//DirectoriesAction
export const GET_ZIP_DIRECTORIES = 'GET_ZIP_DIRECTORIES'
export const GET_DIRECTORIES = 'GET_DIRECTORIES'
export const SET_INDEX_TERRORIST = 'SET_INDEX_TERRORIST'
export const SET_INDEX_SOATO = 'SET_INDEX_SOATO'
export const SET_INDEX_ISSUINGAUTHORITY = 'SET_INDEX_ISSUINGAUTHORITY'
export const OPEN_MODAL = 'OPEN_MODAL'
export const ERROR_MESSAGE = 'ERROR_MESSAGE'
export const CHANGE_DIRECTORIES_CHECKBOX = 'DIRECTORIES_CHECKBOX'
export const SET_TERRORIST_DIRECTORIES = 'SET_TERRORIST_DIRECTORIES'
export const SET_SOATO_DIRECTORIES = 'SET_SOATO_DiRECTORIES'
export const SET_ISSUING_AUTHORITY_DIRECTORIES = 'SET_ISSUING_AUTHORITY_DIRECTORIES'
export const WAITING_ALL_REQUEST_DIRECTORIES = 'WAITING_ALL_REQUEST_DIRECTORIES'
export const LOADER_DIRECTORIES = 'LOADER_DIRECTORIES'
export const OPEN_ALERT_SUCCESS = 'OPEN_ALERT_SUCCESS'

//McsIntegrationAction
export const MIGRATE_CLIENTS_REQUESTED = 'MIGRATE_CLIENTS_REQUESTED'
export const MIGRATE_CLIENTS_SUCCESS = 'MIGRATE_CLIENTS_SUCCESS'
export const MIGRATE_DEALS_REQUESTED = 'MIGRATE_DEALS_REQUESTED'
export const MIGRATE_DEALS_SUCCESS = 'MIGRATE_DEALS_SUCCESS'
export const MIGRATE_ERROR_MESSAGE = 'MIGRATE_ERROR_MESSAGE'
export const CHANGE_STATE_MODAL_MIGRATE = 'CHANGE_STATE_MODAL_MIGRATE'
export const OPEN_ALERT_MIGRATE_SUCCESS = 'OPEN_ALERT_MIGRATE_SUCCESS'
export const SET_INDEX_CLIENTS_REQUESTED = 'SET_INDEX_CLIENTS_REQUESTED'
export const SET_INDEX_CLIENTS_SUCCESS = 'SET_INDEX_CLIENTS_SUCCESS'
export const SET_INDEX_DEALS_REQUESTED = 'SET_INDEX_DEALS_REQUESTED'
export const SET_INDEX_DEALS_SUCCESS = 'SET_INDEX_DEALS_SUCCESS'

//remotelyReportsAction
export const ADD_REMOTE_USER = 'ADD_REMOTE_USER'
export const REMOVE_REMOTE_USER = 'REMOVE_REMOTE_USER'
export const OPEN_REMOTE_REPORTS_MODAL='OPEN_REMOTE_REPORTS_MODAL'

//debtLoadAction
export const DEBTLOAD_LIST_REQUEST = 'DEBTLOAD_LIST_REQUEST'
export const DEBTLOAD_LIST_SUCCESS = 'DEBTLOAD_LIST_SUCCESS'
export const DEBTLOAD_LIST_FAILED='DEBTLOAD_LIST_FAILED'
export const UPDATE_DEBT_LOAD_GROUP_REQUEST = 'UPDATE_DEBT_LOAD_GROUP_REQUEST'
export const UPDATE_DEBT_LOAD_GROUP_SUCCESS = 'UPDATE_DEBT_LOAD_GROUP_SUCCESS'
export const UPDATE_DEBT_LOAD_GROUP_FAILURE ='UPDATE_DEBT_LOAD_GROUP_FAILURE'
export const FETCH_DEBT_LOAD_CALCULATE_REQUEST ='FETCH_DEBT_LOAD_CALCULATE_REQUEST'
export const FETCH_DEBT_LOAD_CALCULATE_SUCCESS ='FETCH_DEBT_LOAD_CALCULATE_SUCCESS'
export const FETCH_DEBT_LOAD_CALCULATE_FAILED ='FETCH_DEBT_LOAD_CALCULATE_FAILED'
export const RESET_DEBT_LOAD_CALCULATE ='RESET_DEBT_LOAD_CALCULATE'
export const GET_CLIENT_LAST_DEBT_LOAD_REQUEST ='GET_CLIENT_LAST_DEBT_LOAD_REQUEST'
export const GET_CLIENT_LAST_DEBT_LOAD_SUCCESS ='GET_CLIENT_LAST_DEBT_LOAD_SUCCESS'
export const GET_CLIENT_LAST_DEBT_LOAD_FAILED ='GET_CLIENT_LAST_DEBT_LOAD_FAILED'
export const GET_DEBT_LOAD_GROUP_REQUEST ='GET_DEBT_LOAD_GROUP_REQUEST'
export const GET_DEBT_LOAD_GROUP_SUCCESS ='GET_DEBT_LOAD_GROUP_SUCCESS'
export const GENERATE_DEBT_OVERLOAD_REPORT ='GENERATE_DEBT_OVERLOAD_REPORT'
export const IS_SIGNED_NOTIFICATION ='IS_SIGNED_NOTIFICATION'
export const FETCH_DEBT_LOAD_REPORT_REQUEST = "FETCH_DEBT_LOAD_REPORT_REQUEST";
export const FETCH_DEBT_LOAD_REPORT_SUCCESS = "FETCH_DEBT_LOAD_REPORT_SUCCESS";
export const FETCH_DEBT_LOAD_REPORT_FAILED = "FETCH_DEBT_LOAD_REPORT_FAILED";
export const CALCULATE_DEBT_LOAD_REQUEST = 'CALCULATE_DEBT_LOAD_REQUEST';

//autoLombardActions
export const FETCH_REQUESTS = 'FETCH_REQUESTS';
export const STATE_ERROR = 'STATE_ERROR';
export const FETCH_REQUESTS_SUCCESS = 'FETCH_REQUESTS_SUCCESS';
export const FETCH_REQUESTS_FAILURE = 'FETCH_REQUESTS_FAILURE';
export const FETCH_PAYMENT_SCHEDULE_SUCCESS = 'FETCH_PAYMENT_SCHEDULE_SUCCESS';
export const APPROVE_ERROR = 'APPROVE_ERROR';
export const FETCH_PAYMENT_SCHEDULE_REQUEST = 'FETCH_PAYMENT_SCHEDULE_REQUEST';
export const FETCH_PAYMENT_SCHEDULE_FAILED = 'FETCH_PAYMENT_SCHEDULE_FAILED';
export const FETCH_REQUEST = 'FETCH_REQUEST';
export const FETCH_REQUEST_SUCCESS = 'FETCH_REQUEST_SUCCESS';
export const SET_COMMENTS_SUCCESS = 'SET_COMMENTS_SUCCESS';
export const FETCH_REQUEST_FAILURE = 'FETCH_REQUEST_FAILURE';
export const APPROVE_REQUEST = 'APPROVE_REQUEST';
export const SET_COMMENTS = 'SET_COMMENTS';
export const CHANGE_HISTORY = 'CHANGE_HISTORY';
export const CHANGE_HISTORY_SUCCESS = 'CHANGE_HISTORY';
export const APPROVE_REQUEST_SUCCESS = 'APPROVE_REQUEST_SUCCESS';
export const RESET_PAYMENT_SCHEDULE = 'RESET_PAYMENT_SCHEDULE';
export const APPROVE_REQUEST_FAILURE = 'APPROVE_REQUEST_FAILURE';
export const REJECT_REQUEST = 'REJECT_REQUEST';
export const REJECT_REQUEST_SUCCESS = 'REJECT_REQUEST_SUCCESS';
export const REJECT_REQUEST_FAILURE = 'REJECT_REQUEST_FAILURE';
export const CANCEL_REQUEST = 'CANCEL_REQUEST';
export const WITHDRAW_CAR_DEPOSIT_REQUEST = 'WITHDRAW_CAR_DEPOSIT_REQUEST';
export const CANCEL_REQUEST_SUCCESS = 'CANCEL_REQUEST_SUCCESS';
export const CANCEL_REQUEST_FAILURE = 'CANCEL_REQUEST_FAILURE';
export const GET_REQUEST_CLIENTS = 'GET_REQUEST_CLIENTS';
export const GET_REQUEST_CLIENTS_SUCCESS = 'GET_REQUEST_CLIENTS_SUCCESS';
export const GET_REQUEST_CLIENTS_FAILURE = 'GET_REQUEST_CLIENTS_FAILURE';
export const FETCH_DOCUMENT_REQUEST = 'FETCH_DOCUMENT_REQUEST';
export const FETCH_DOCUMENT_SUCCESS = 'FETCH_DOCUMENT_SUCCESS';
export const FETCH_DOCUMENT_FAILURE = 'FETCH_DOCUMENT_FAILURE';
export const INPROGRESS_STATUS_REQUEST = 'INPROGRESS_STATUS_REQUEST';
export const INPROGRESS_STATUS_SUCCESS = 'INPROGRESS_STATUS_SUCCESS';
export const INPROGRESS_STATUS_FAILURE = 'INPROGRESS_STATUS_FAILURE';
export const UPDATE_REQUEST = 'UPDATE_REQUEST';
export const UPDATE_REQUEST_SUCCESS = 'UPDATE_REQUEST_SUCCESS';
export const UPDATE_REQUEST_FAILURE = 'UPDATE_REQUEST_FAILURE';
export const CREATE_ONEAPP_CLIENT_REQUEST = 'CREATE_ONEAPP_CLIENT_REQUEST';
export const CREDIT_REGISTER_REQUEST = 'CREDIT_REGISTER_REQUEST';
export const CREATE_ONEAPP_CLIENT_SUCCESS = 'CREATE_ONEAPP_CLIENT_SUCCESS';
export const CREDIT_REGISTER_SUCCESS = 'CREDIT_REGISTER_SUCCESS';
export const CREDIT_REGISTER_FAILED = 'CREDIT_REGISTER_FAILED';
export const RESET_ERROR = 'RESET_ERROR';
export const CREATE_ONEAPP_CLIENT_FAILURE = 'CREATE_ONEAPP_CLIENT_FAILURE';
export const AUTO_DEBT_LOAD_REQUEST = 'AUTO_DEBT_LOAD_REQUEST';
export const AUTO_DEBT_LOAD_SUCCESS = 'AUTO_DEBT_LOAD_SUCCESS';
export const AUTO_DEBT_LOAD_FAILURE = 'AUTO_DEBT_LOAD_FAILURE';
export const GENERATE_CREDIT_CALCULATION_REPORT = 'GENERATE_CREDIT_CALCULATION_REPORT';
